import { Box, Link } from "@mui/material";
import { useEffect, useState } from "react";

const CarouselPagination = (props) => {
    const {
        currentPage,
        totalPages,
        highlightedPages,
        onPageChange,
        children,
    } = props;
    const [pages, setPages] = useState([]);
    const highlightedPageColour = "#888888";
    const normalPageColour = "#000000";

    useEffect(() => {
        buildPagination();
    }, [currentPage]);

    const pageIsHighlighted = (page) => {
        return highlightedPages.includes(page);
    };

    const buildPagination = () => {
        let pages = [];
        if (totalPages === 1) return;
        // if there are less than 5 pages, show all
        if (totalPages <= 5) {
            for (let i = 0; i <= totalPages - 1; i++) {
                pages.push(i);
                setPages(pages);
            }
        }

        // if there are more than 5 pages, show the first, two dots, the current page, two dots, and the last page
        if (totalPages > 5) {
            // if the current page is the first page
            if (currentPage <= 2) {
                setPages([0, 1, 2, "...", totalPages - 1]);
            }

            // if the current page is the last page
            if (currentPage === totalPages - 1) {
                setPages([
                    0,
                    "...",
                    totalPages - 3,
                    totalPages - 2,
                    totalPages - 1,
                ]);
            }

            // if the current page is in the middle
            if (currentPage >= 2 && currentPage < totalPages - 1) {
                setPages([
                    0,
                    "...",
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    "...",
                    totalPages - 1,
                ]);
            }

            // if the current page is the last three pages
            if (currentPage >= totalPages - 3) {
                setPages([
                    0,
                    "...",
                    totalPages - 3,
                    totalPages - 2,
                    totalPages - 1,
                ]);
            }
        }
    };

    const renderPagination = () => {
        return pages.map((page, index) => {
            if (page === "...") {
                return "...";
            }
            return (
                <Link
                    key={index}
                    onClick={() => onPageChange(page)}
                    style={{
                        fontSize: "0.8rem",
                        cursor: "pointer",
                        color: pageIsHighlighted(page)
                            ? highlightedPageColour
                            : page === currentPage
                            ? "var(--siteconfig-ui-logoutbtn-bgcolor)"
                            : normalPageColour,
                        textDecoration:
                            page === currentPage ? "underline" : "none",
                        margin: "0 2px",
                        borderRadius: "5px",
                    }}
                >
                    {page + 1}
                </Link>
            );
        });
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
            }}
            className="carousel-pagination"
        >
            {children}
            {renderPagination()}
        </Box>
    );
};

export default CarouselPagination;
